<!--
 * @Author: your name
 * @Date: 2020-05-14 14:55:11
 * @LastEditTime: 2021-01-25 10:55:11
 * @LastEditors: Niu Chenxin
 * @Description: In User Settings Edit
 * @FilePath: \xingmahui_front\src\components\emptyList.vue
--> 
<template>
  <div class="list-empty">
    <!-- 内容 -->
    <div class="empty-content" :style="{'padding':emptyText?'40px 0':'118px 0'}">
      <div class="empty-img"><img src="../../assets/images/common/xiaohe1.png" /></div>
      <p class="empty-desc">{{emptyText?emptyText:'暂时没有内容哦～'}}</p>
    </div>
  </div>
</template>

<style lang="less" scoped>
.list-empty {
  background: @expertFontColor255;
  .empty-content {
    width: 100%;
    height: 157px;
    margin: 0 auto;
    padding: 118px 0;
    .empty-img {
      width: 128px;
      height: 128px;
      margin: 0 auto;
      img {
        width: 100%;
        display: block;
      }
    }
    .empty-desc {
      font-size: 14px;
      color: @expertFontColor51;
      line-height: 16px;
      text-align: center;
      span {
        font-size: 14px;
        color: @mainColor;
        border-bottom: 1px solid #f1be46;
      }
    }
  }
}
</style>

<script>
export default {
  props: ["emptyText"],
  mounted () {
    // $(".list-empty").css("height",$("body").height()+"px");
    $(window).resize(function () {
      $(".list-empty").css("height", $("body").height() + "px");
    });

  },
  methods: {
    toHomeHander () {
      // this.$router.push("/home");
      location.href = '/home'
    }
  },

}
</script>